import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { FaSignOutAlt } from "react-icons/fa";
import { logoutMember } from "../../api/API";

const LogOut = ({ onLogout }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await logoutMember();
      toast.success("Logged out successfully!");

      //  Trigger global auth state change
      window.dispatchEvent(new Event("authChange"));

      if (typeof onLogout === "function") {
        onLogout();
      }

      navigate("/login");
    } catch (error) {
      console.error("Logout failed:", error);
      toast.error("Failed to logout. Please try again.");
    }
  };

  return (
    <button
      className="btn btn-primary d-flex align-items-center justify-content-center"
      style={{
        width: "38px",
        height: "38px",
        padding: 0,
        borderRadius: "50%",
      }}
      onClick={handleLogout}
      title="Logout"
    >
      <FaSignOutAlt className="text-white" size={20} />
    </button>
  );
};

export default LogOut;
